import { ITEM_TYPE_CODES } from '@/composables/api/NavigationSearch.js'
import type { MirageServer, MockServer } from '../server.js'

export function seeds(server: MockServer) {
  void server.lazySeedingManager?.seedBasic('OrganizationItem')
}

export function routes(server: MockServer) {
  // GET /catalog/items/v1 - Get item options for dropdown
  server.get(
    '/catalog/items/v1',
    function (this: MirageServer, schema, request) {
      const allItems = schema.all('organizationItem')
      const search = request.queryParams['filter[search]']

      let filteredItems = allItems.models

      if (search) {
        const searchValue = Array.isArray(search) ? search[0] : search
        const searchLower = searchValue.toLowerCase()
        filteredItems = filteredItems.filter((item) =>
          item.attrs.name?.toLowerCase().includes(searchLower),
        )
      }

      // Map type_code to display name
      const typeDisplayMap: Record<number, string> = {
        [ITEM_TYPE_CODES.PROCEDURE]: 'Procedure',
        [ITEM_TYPE_CODES.MEDICINE]: 'Medicine',
        [ITEM_TYPE_CODES.SUPPLY]: 'Supply',
        [ITEM_TYPE_CODES.FOOD]: 'Food',
        [ITEM_TYPE_CODES.LABORATORY_ANALYSIS]: 'Laboratory',
        [ITEM_TYPE_CODES.LABORATORY_ANALYSIS_PANEL]: 'Laboratory Panel',
      }

      return {
        data: filteredItems.map((item) => ({
          id: item.id,
          type: 'ItemOption',
          attributes: {
            name: item.attrs.name,
            type_code: item.attrs.type_code,
            type_display: typeDisplayMap[item.attrs.type_code] || 'Unknown',
          },
        })),
      }
    },
  )
}
